// src/components/NotreEngagement.js
import React from 'react';
import './NotreEngagement.css'; // Fichier CSS pour les styles spécifiques

function NotreEngagement() {
  return (
    <section id="notre-engagement" className="commitment-section">
      <div className="container">
        {/* Le titre principal utilisera le style global .section-title que nous avons déjà agrandi */}
        <h2 className="section-title">Notre Engagement pour Vos Cheveux et la Planète</h2>
        <p className="commitment-intro">
          Chez Studio Ambre, nous sommes passionnés par la beauté authentique qui respecte à la fois la nature de vos cheveux,
          votre santé et notre environnement. C'est pourquoi nous avons fait le choix d'une coiffure plus consciente,
          en privilégiant l'expertise végétale et des partenaires partageant nos valeurs d'excellence et de naturalité,
          tels que <strong className="brand-highlight">Couleurs Gaïa</strong> et <strong className="brand-highlight">UMAÏ</strong>.
        </p>

        <div className="commitment-grid">
          <div className="commitment-column">
            <h3 className="commitment-subtitle">L'Excellence de la Coloration 100% Végétale</h3>
            <img src="/images/logogaia.jpg" alt="Logo Couleurs Gaïa" className="brand-logo gaia-logo" /> {/* REMPLACEZ par le vrai logo */}
            <p>
              Inspirés par la richesse de la nature, nous vous proposons les colorations <strong className="brand-highlight">Couleurs Gaïa</strong>,
              composées uniquement de plantes tinctoriales et ayurvédiques. Ces poudres pures, mélangées à de l'eau chaude,
              enrobent délicatement chaque cheveu sans en ouvrir les écailles ni altérer son pH.
            </p>
            <ul className="commitment-list">
              <li>Couverture parfaite des cheveux blancs et résultats durables.</li>
              <li>Véritable soin traitant : brillance, volume et vitalité retrouvés.</li>
              <li>Chevelure respectée, cuir chevelu apaisé.</li>
              <li>Couleurs uniques, lumineuses et personnalisées par notre savoir-faire.</li>
              <li>Une alternative saine, sans ammoniaque, PPD, ni produits de synthèse.</li>
            </ul>
            <p>
              La coloration végétale est un art qui allie la pureté des plantes à une application experte pour un résultat sublime et une chevelure rayonnante de santé.
            </p>
          </div>

          <div className="commitment-column">
            <h3 className="commitment-subtitle">Soins Capillaires Naturels, Innovants et Engagés</h3>
            <img src="/images/logoumai.png" alt="Logo UMAÏ" className="brand-logo umai-logo" /> {/* REMPLACEZ par le vrai logo */}
            <p>
              Notre partenariat avec <strong className="brand-highlight">UMAÏ</strong> reflète notre désir de vous offrir des soins d'exception,
              bons pour vous et pour la planète. UMAÏ incarne une cosmétique nouvelle génération :
            </p>
            <ul className="commitment-list">
              <li>Formulations saines, issues de l'expertise botanique et de l'innovation durable.</li>
              <li>Ingrédients naturels de haute qualité, privilégiant les filières françaises et européennes.</li>
              <li>Engagement zéro déchet : des soins solides pour réduire l'usage du plastique.</li>
              <li>Efficacité prouvée, même pour les cuirs chevelus les plus sensibles.</li>
              <li>Transparence totale sur la provenance et la composition des produits.</li>
            </ul>
            <p>
              Avec UMAÏ, nous vous proposons des rituels de soins qui allient sensorialité, performance et respect de l'environnement, pour une beauté consciente et rayonnante.
            </p>
          </div>
        </div>

        <p className="commitment-conclusion">
          Au Studio Ambre, chaque diagnostic est personnalisé. Nous prenons le temps de vous écouter pour vous conseiller
          les soins et colorations végétales les plus adaptés à la nature de vos cheveux et à vos envies.
        </p>
      </div>
    </section>
  );
}

export default NotreEngagement;